import React from 'react'
import { Dropdown, Nav, Tab } from 'react-bootstrap'

import './ContentHeaderNav.scss'

export interface ContentHeaderNavTab {
  label: string
  icon: string | JSX.Element
  onClick: any
  className?: string
  active?: boolean
  disabled?: boolean
  badge?: string | number
}

interface Props {
  tabs: ContentHeaderNavTab[]
}

const ContentHeaderToolbarNav = ({ tabs }: Props) => {

  const activeTab = tabs.find(tab => tab.active) || tabs[0]

  return (
    <div className="ul-widget__head-nav">
      <Tab.Container>
        <Nav as="ul" className="nav-tabs nav-tabs-line nav-tabs-bold">
          {tabs.map((tab: ContentHeaderNavTab, i: number) => (
            <Nav.Item key={i} as="li">
              <Nav.Link
                aria-label={tab.label}
                title={tab.label}
                className={tab.className || ''}
                active={tab.active}
                disabled={tab.disabled}
                onClick={() => !tab.disabled && tab.onClick()}
              >
                {tab.icon}
                <span className="hide-on-mobile"> {tab.label}</span>
                {tab.badge !== undefined && (
                  <span className="pl4-tab-count">{tab.badge}</span>
                )}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </Tab.Container>

      {activeTab && (
        <Dropdown className="pl4-mobile-submenu-selector">
          <Dropdown.Toggle
            as="button"
            type="button"
            className="pl4-mobile-submenu-selector__toggle"
            aria-label={activeTab.label}
          >
            <span className="pl4-mobile-submenu-selector__label">{activeTab.label}</span>
            {activeTab.badge !== undefined && <span className="pl4-tab-count">{activeTab.badge}</span>}
            <i className="fas fa-chevron-down" aria-hidden="true" />
          </Dropdown.Toggle>

          <Dropdown.Menu className="pl4-mobile-submenu-selector__menu">
            {tabs.map((tab, index) => (
              <Dropdown.Item
                as="button"
                key={index}
                className="pl4-mobile-submenu-selector__item"
                active={tab.active}
                disabled={tab.disabled}
                onClick={() => !tab.disabled && tab.onClick()}
              >
                <span className="pl4-mobile-submenu-selector__check-slot" aria-hidden="true">
                  {tab.active && <i className="fas fa-check" />}
                </span>
                <span className="pl4-mobile-submenu-selector__item-label">{tab.label}</span>
                {tab.badge !== undefined && <span className="pl4-tab-count">{tab.badge}</span>}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  )
}

export default ContentHeaderToolbarNav
